import React, { useEffect, useState } from "react";
import { Box, Grid, TableCell, TableRow, Typography } from "@mui/material";
import CustomButton from "../../../components/common/button/CustomButton";
import ManageVehicleType from "./ManageVehicleType";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getVehicleTypes,
  setAddVehicleTypeResponse,
} from "../../../store/reducers/vehicleSlice";
import TableDesign, {
  TableHeading,
} from "../../../components/common/table/TableDesign";
import PageTitle from "../../../components/pageTitle/PageTitle";

interface VehicleTypeListProps {
  setSelectedId: (id: any | null) => void;
  selectedId: any | null;
}

const VehicleTypeList: React.FC<VehicleTypeListProps> = ({
  setSelectedId,
  selectedId,
}) => {
  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Vehicle Type", align: "left" },
  ];
  const [open, setOpen] = useState(false);
  const { vehicleTypes, isAddVehicleTypeResponse, isDeleteVehicleTypeResponse } =
    useSelector((state: any) => state.vehicle);
  const dispatch = useDispatch();

  useEffect(() => {
    if (vehicleTypes.length > 0 && !selectedId) {
      console.log("API calling-36");
      setSelectedId(vehicleTypes[0].id); // auto-select first vehicle
    }
  }, [vehicleTypes, selectedId, setSelectedId]);

  useEffect(() => {
    dispatch(getVehicleTypes());
  }, [dispatch]);

  useEffect(() => {
    if (isAddVehicleTypeResponse || isDeleteVehicleTypeResponse) {
      setOpen(false);
      dispatch(getVehicleTypes());
      dispatch(setAddVehicleTypeResponse(false));
    }
  }, [isAddVehicleTypeResponse,isDeleteVehicleTypeResponse]);

  return (
    <>
      {open && (
        <ManageVehicleType
          open={open}
          onHide={() => setOpen(false)}
          title="New Vehicle Type"
          selectedVehicle={{}}
          setSelectedVehicle={() => {}}
          action="add"
        />
      )}

      <Grid container sx={{ height: "100%" }}>
        <Grid
          item
          md={12}
          xs={12}
          id="userList"
          sx={{ paddingLeft: "0px !important", height: "100%" }}
        >
          <PageTitle
            title="Vehicle"
            button="Add New"
            onClick={() => setOpen(true)}
          />
          <TableDesign
            tableHeadings={tableHeadings}
            pagination={undefined}
            filterOption={""}
            stickyHeader={true}
            setFilterOption={() => {}}
            tableHeadColor="#E5F4F1"
            extraCSS={{
              height: "calc(100% - 100px)",
            }}
          >
            {vehicleTypes.length > 0 ? (
              vehicleTypes.map((val: any, idx: number) => (
                <TableRow
                  key={val?.id}
                  onClick={() => setSelectedId(val?.id)}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    backgroundColor:
                      selectedId === val?.id ? "#f0f0f0" : "transparent", // ✅ active row bg
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell align="left">{idx + 1}</TableCell>
                  <TableCell>{val?.vehicle_type}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  No vehicle type found.
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Grid>
      </Grid>
    </>
  );
};

export default VehicleTypeList;
